import(/* webpackMode: "eager", webpackExports: ["AboutPageContent"] */ "/app/components/frontend/about/about-page-content.tsx");
